import styled from "styled-components";

import { Button, FormControl, InputGroup } from "react-bootstrap";

export const ButtonWrapper = styled(Button)`
    width: 100%;
`;

interface IRowWrapperProps {
    showHighlight?: boolean,
    padding?: string,
    useBackupPlan?: boolean,
    backgroundColor?: string,
    textColor?: string,
    borderColor?: string
}

export const RowWrapper = styled.tr`
    & > td {
        background-color: ${(p: IRowWrapperProps) => p.useBackupPlan ? "#660000" : (p.backgroundColor ? p.backgroundColor : "#133366")};
        vertical-align: middle !important;
        padding: ${(p: IRowWrapperProps) => p.padding != null ? p.padding : "3px !important"};
        color: ${(p: IRowWrapperProps) => p.textColor ? p.textColor : 'white'};
        height: 31px;
        border-top: 1px solid ${(p: IRowWrapperProps) => p.borderColor ? p.borderColor : '#eee'} !important;

        a:link,
        a:visited {
            color: white;
            text-decoration: none;
        }

        a:hover,
        a:active {
            color: white;
            text-decoration: underline;
        }
    }
`;

export const RowWrapperEmpty = styled.tr`
    & > td {
        background-color: white;
        padding: 0px !important;
    }
`;

export const DetailButtonWrapper = styled(Button)`
    padding: 2px;
    font-size: 10px;
`;

interface IFormControlWrapperProps {
    fontSize?: number
}

export const FormControlWrapper = styled(FormControl)`
    padding: 3px 6px;
    height: 26px;
    font-size: ${(p: IFormControlWrapperProps) => p.fontSize ? p.fontSize + "px !important" : "14px"}
`;

export const FormControlStaticWrapper = styled(FormControl.Static)`
    padding: 2px 6px;
    min-height: 26px;
    font-size: ${(p: IFormControlWrapperProps) => p.fontSize ? p.fontSize + "px !important" : "14px"};
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #eee;
`;